import React from 'react';
import '../styles/train.css';
import Modal from 'react-modal';

const ExerciseVideoModal = ({ isOpen, onClose, videoUrl }) => {
    const getVideoId = (url) => {
        const match = url.match(/(?:youtu\.be\/|youtube\.com(?:\/embed\/|\/v\/|\/watch\?v=|\/watch\?.+&v=))([\w-]{11})/);
        return match ? match[1] : null;
    };

    const videoId = getVideoId(videoUrl);
    const embedUrl = `https://www.youtube.com/embed/${videoId}`;

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            className="video-modal"
            overlayClassName="video-modal-overlay"
        >
            <div className="video-modal-content">
                <button onClick={onClose} className="close-modal">×</button>
                <div className="video-container">
                    <iframe
                        src={embedUrl}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    ></iframe>
                </div>
                <button 
                    className="back-to-training-btn"
                    onClick={onClose}
                >
                    Back to Training
                </button>
            </div>
        </Modal>
    );
};

export default ExerciseVideoModal; 